import { IconContext } from 'react-icons';
import React from 'react';
import { AlertType } from '../../../../store/alerts/types';

export interface Props {
  alert: AlertType;
  openEdit(): void;
}

export const AlertRow = (props: Props) => {
  const columnClass = 'event-row__element';
  const {
    alert: { uid_hash, name, severity_level, is_active },
    openEdit,
  } = props;

  const strIsActive = is_active ? 'yes' : 'no';

  return (
    <span key={uid_hash} className="alert-row" onClick={openEdit}>
      <div className={columnClass}>{name}</div>
      <div className={columnClass}>{severity_level}</div>
      <div className={columnClass}>{strIsActive}</div>
    </span>
  );
};
